import {AxiosResponse} from "axios";

import CoreApi from "@/src/modules/core/api";
import getParams from "@/src/modules/core/lib/params";
import axios from "@/src/modules/core/lib/axios";
import {GetListResponse, GetResponse, ParamsOptions} from "@/src/modules/core/types";

import type {
  CompanyOnGuardAssignee,
  CompanyOnGuardAssigneeForCreate,
  CompanyOnGuardAssigneeForUpdate,
} from "../types";

class CompanyOnGuardApi extends CoreApi {
  getAssignees(
    companyId: number,
    options?: ParamsOptions,
  ): Promise<AxiosResponse<GetListResponse<CompanyOnGuardAssignee>>> {
    return axios({
      url: `companies/${companyId}/on-guard-users`,
      method: "get",
      params: getParams(options),
    });
  }

  getAssignee(
    companyId: number,
    assigneeId: number,
  ): Promise<AxiosResponse<GetResponse<CompanyOnGuardAssignee>>> {
    return super.getById(`companies/${companyId}/on-guard-users`, assigneeId);
  }

  createAssignee(
    companyId: number,
    data: CompanyOnGuardAssigneeForCreate,
  ): Promise<AxiosResponse<GetResponse<CompanyOnGuardAssignee>>> {
    return super.create(`companies/${companyId}/on-guard-users`, data);
  }

  updateAssignee(
    companyId: number,
    assigneeId: number,
    data: CompanyOnGuardAssigneeForUpdate,
  ): Promise<AxiosResponse<GetResponse<CompanyOnGuardAssignee>>> {
    return super.update(`companies/${companyId}/on-guard-users`, assigneeId, data);
  }

  deleteAssignee(companyId: number, assigneeId: number): Promise<AxiosResponse<void>> {
    return super.delete(`companies/${companyId}/on-guard-users`, assigneeId);
  }
}

export const companyOnGuardApi = new CompanyOnGuardApi();
